// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { ACTIVE_COMPANY_SERVICES } from 'constants';
import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons';
import { SortableTH } from 'components/content-containers/tables';
import { Table } from 'components/content-containers/tables/tables';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import ClientRow from 'components/models/company/client-row';
import Company from 'services/data/company';
import Filters from 'modules/filters/filters';
import Pager from 'components/widgets/pager/pager';
import Tooltip from 'components/widgets/overlays/tooltip';
import exportCSV from 'utils/export-csv';

import * as actions from './store/actions';

// Component
class Companies extends React.Component {
  static propTypes = {
    companies: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object,
    users: PropTypes.array,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.search = this.search.bind(this);
    this.export = this.export.bind(this);

    this.filterConfig = {
      basic: ['search'],
      advanced: [
        ['search', 'team', 'primaryTech'],
        ['status', 'paymentStatus']
      ],
      defaults: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  componentWillUnmount() {
    actions.set({ companies: [], count: null });
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = Company.formatQuery(query || this.props.query);
    fullQuery.where.companyType = 'Client';
    fullQuery.load = ['defaultAgreement', 'employees'];

    return Promise.props({
      companies: Company.find(fullQuery),
      count: Company.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, companies: response.companies, count: response.count });
      })
      .catch(alerts.catchError);
  }

  export() {
    const fullQuery = Company.formatQuery(this.props.query);
    delete fullQuery.limit;

    Company.find(fullQuery)
      .then((companies) => {
        const header = ['Name'];

        const data = _.map(companies, company => [
          _.get(company, 'name', '')
        ]);

        exportCSV(data, 'clients.csv', { header });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { companies = [], count = 0, fetching } = this.props;

    const headerActions = (
      <div className="header-actions">
        <PrimaryButton onClick={this.export} disabled={_.isEmpty(companies)}>Export</PrimaryButton>
      </div>
    );

    return (
      <Page>
        <PageHeader title="Clients" actions={headerActions}>
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No clients, adjust your filters!"
          emptyTextIcon="svg/company.svg"
          showEmptyText={!fetching && _.isEmpty(companies)}
          className="companies"
        >
          <div className="companies-table">
            <Table>
              <thead>
                <tr>
                  <SortableTH sortField="name">Name</SortableTH>
                  <th>Default Contract</th>
                  <th>Employees</th>
                  <th>Users</th>
                  <th className="right-align">Balance</th>
                  {_.map(ACTIVE_COMPANY_SERVICES, service =>
                    <th className="collapse-width grid-cell" key={service}>
                      <Tooltip title={_.startCase(service)}>
                        {_(service).words().map(_.head).map(_.toUpper).join('')}
                      </Tooltip>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {_.map(companies, (company) => <ClientRow key={company.id} company={company} />)}
              </tbody>
            </Table>
          </div>
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  companies: state.companies.companies,
  fetching: state.companies.fetching,
  users: state.pageData.selectUsers,
  count: state.companies.count,
  query: state.location.query,
  currentUser: state.auth.currentUser
}))(Companies);
